/* @flow weak */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';
import { cloneDeep } from 'lodash';

export default class OrganizationDetails extends Entity {
  getCreatedAt() {
    return this.get('created_at');
  }

  getName() {
    return this.get('name');
  }

  getTeacherCount() {
    return this.get('teacher_count');
  }

  getClassCount() {
    return this.get('class_count');
  }

  getSubscriberCount() {
    return this.get('subscriber_count');
  }

  getMessageCount() {
    return this.get('message_count');
  }

  parse(response: Object) {
    return cloneDeep(response);
  }

  static getByOrganizationId(organizationId: number) {
    return apiRequest(`/organizations/${organizationId}/statistics`, 'GET')
      .then(orgDetails => OrganizationDetails.fromJSON(orgDetails));
  }
}



// WEBPACK FOOTER //
// ./src/admin/entities/OrganizationDetails.js